import Notifications from '../screens/Notifications'
import { allRoles, RouteWithAccessType } from './types'

const notificationRoleManagement: RouteWithAccessType[] = [
  {
    route: '/notifications',
    exact: true,
    rolesListWithReadAccess: allRoles,
    rolesListWithWriteAccess: allRoles,
    requiredFeatures: [],
    component: <Notifications />
  },
  {
    // Estate configuration, kept off the personal surface. Every user has an
    // inbox; a handful administer the catalogue, and mixing them gave most
    // users six tabs they could never open.
    //
    // Access stays allRoles because the tabs themselves are capability-gated
    // (buildNotificationTabs returns nothing without adminRead/providerRead) and
    // notification-service re-checks on every call. Restricting the ROUTE by
    // role here would duplicate that check in a third place and drift from it.
    route: '/notification-management',
    exact: true,
    rolesListWithReadAccess: allRoles,
    rolesListWithWriteAccess: allRoles,
    requiredFeatures: [],
    component: <Notifications surface="management" />
  }
]

export default notificationRoleManagement
